import React, { useState, useEffect, useContext } from 'react';
import clsx from 'clsx';
import styled from '@emotion/styled';

import useDeviceDetect from '@hooks/useDeviceDetect';
import useWindowSize from '@hooks/useWindowSize';

import { revealFromBottom } from '@styles/keyframes';
import API from '@lib/API';
// import Cookies from '@utils/cookie';

import FilmrModal from './FilmrModal';
import { StateContext } from '@store/store';

function StickyFilmr({
  // showFilmrPopup,
  filmrLinks = {
    iOS: 'https://filmrapp.onelink.me/9iEj/8d9711a1',
    android: 'https://filmrapp.onelink.me/AezS/61d0774b',
  },
}) {
  const api = new API();
  const { deviceType, deviceOS } = useDeviceDetect();
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [modalFiredOnload, setModalFiredOnload] = useState(false);
  const state = useContext(StateContext);

  const { isMediaMatched } = useWindowSize('max-width: 640px');

  // const checkModal = useCallback(() => {
  //   const isFilmrCookiePresent = Cookies.check('showFilmrModal');

  //   if (
  //     !!showFilmrPopup &&
  //     deviceType === 'mobile' &&
  //     !isFilmrCookiePresent &&
  //     isMediaMatched
  //   ) {
  //     setIsModalOpen(!!showFilmrPopup);
  //     setModalFiredOnload(prevState => !prevState);
  //   } else {
  //     setIsModalOpen(false);
  //   }
  // }, [isMediaMatched, deviceType, showFilmrPopup]);

  // useEffect(() => {
  //   // Show Modal After 5 Seconds on Page Load
  //   let modalTimer;
  //   if (!modalFiredOnload) {
  //     modalTimer = setTimeout(checkModal, 5000);
  //   }

  //   return () => {
  //     if (modalTimer) {
  //       clearTimeout(modalTimer);
  //     }
  //   };
  // }, [checkModal, modalFiredOnload]);

  useEffect(() => {
    if (!isMediaMatched) {
      setIsModalOpen(false);
    }
  }, [isMediaMatched]);

  useEffect(() => {
    const copyRightContainer = document.getElementById('copyRightContainer');
    if (copyRightContainer) {
      if (deviceType === 'mobile') {
        copyRightContainer.classList.add('mb-20');
      } else {
        copyRightContainer.classList.remove('mb-20');
      }
    }
  }, [deviceType]);

  const closeModal = () => {
    // Set Modal Cookie for 1 Day
    // document.cookie = `showFilmrModal=false; max-age=${60 * 60 * 24}`;
    setIsModalOpen(false);
  };

  const openModal = () => {
    if (isMediaMatched) {
      setIsModalOpen(true);
    }
  };

  const onClickDownloadLink = () => {
    api.sendAmplitudeEvent('Download app click', {
      'Operating System': deviceOS,
    });
  };

  if (
    deviceType !== 'mobile' ||
    location.pathname.includes('make/real-estate-marketing')
  ) {
    return null;
  }

  return (
    <React.Fragment>
      <FilmrBanner
        className={clsx(
          'fixed mx-auto w-full bottom-0 h-20 overflow-hidden',
          (state.questionModal.state ||
            state.authModal.state ||
            state.teamInviteModal.state ||
            state.personaModal.state) &&
            'hidden',
        )}
      >
        <div
          className={clsx(
            'background h-full flex w-full items-center',
            isModalOpen && 'hidden',
          )}
        >
          <div className="absolute concentric-cirle" />
          <button
            className="text flex items-center outline-none text-left h-full w-2/3 p-2"
            type="button"
            onClick={openModal}
          >
            <img
              className="w-10 xs:w-12 mx-2"
              src="https://d2nb51khh83712.cloudfront.net/static-assets/images/filmr/filmr-logo.png"
              alt="Filmr"
            />
            <span>
              <span className="title font-bold text-shadow xs:leading-4 xs:text-sm text-xs uppercase text-white block">
                Filmr by InVideo
              </span>
              <span className="subtitle text-xs xs:leading-4 text-shadow xs:text-sm text-white block">
                The easiest way to make videos on your mobile
              </span>
            </span>
          </button>
          <div className="w-1/3 flex mx-3">
            <a
              href={deviceOS === 'iOS' ? filmrLinks.iOS : filmrLinks.android}
              onClick={onClickDownloadLink}
              target="_blank"
              rel="noopener noreferrer"
              className="mx-auto"
            >
              <img
                className=""
                src={
                  deviceOS === 'iOS'
                    ? 'https://d2nb51khh83712.cloudfront.net/static-assets/images/filmr/badge-ios.svg'
                    : 'https://d2nb51khh83712.cloudfront.net/static-assets/images/filmr/badge-android.svg'
                }
                alt="App Store Icon"
              />
            </a>
          </div>
        </div>
      </FilmrBanner>
      <FilmrModal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        filmrLinks={filmrLinks}
        onClickDownloadLink={onClickDownloadLink}
      />
    </React.Fragment>
  );
}

export default StickyFilmr;

const FilmrBanner = styled.div`
  height: 82px;
  z-index: 9999;
  /* transform: translateY(100%); */
  background: linear-gradient(180deg, #3ea3fe 0%, #0387fe 100%);
  border-radius: 10px 10px 0px 0px;

  .text-shadow {
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
  }

  .subtitle {
    font-size: 13px;
  }
  /* animation: ${revealFromBottom} 0.3s 0.5s ease-in forwards; */
  .concentric-cirle {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    width: 160px;
    height: 160px;
    left: -3rem;
    top: -2rem;
    z-index: -10;

    &:after {
      content: '';
      border-radius: 50%;
      position: absolute;
      width: 240px;
      height: 240px;
      top: calc(50% - 120px);
      left: calc(50% - 120px);
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);
    }
    &:before {
      content: '';
      border-radius: 50%;
      position: absolute;
      width: 320px;
      height: 320px;
      top: calc(50% - 160px);
      left: calc(50% - 160px);
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);
    }
  }
`;
